'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _routeRecognizer = require('route-recognizer');

var _routeRecognizer2 = _interopRequireDefault(_routeRecognizer);

var _routerApi = require('./router/api');

var _routerApi2 = _interopRequireDefault(_routerApi);

var _routerInternal = require('./router/internal');

var _routerInternal2 = _interopRequireDefault(_routerInternal);

var _directivesView = require('./directives/view');

var _directivesView2 = _interopRequireDefault(_directivesView);

var _directivesLink = require('./directives/link');

var _directivesLink2 = _interopRequireDefault(_directivesLink);

var _override = require('./override');

var _override2 = _interopRequireDefault(_override);

var _historyAbstract = require('./history/abstract');

var _historyAbstract2 = _interopRequireDefault(_historyAbstract);

var _historyHash = require('./history/hash');

var _historyHash2 = _interopRequireDefault(_historyHash);

var _historyHtml5 = require('./history/html5');

var _historyHtml52 = _interopRequireDefault(_historyHtml5);

var historyBackends = {
  abstract: _historyAbstract2['default'],
  hash: _historyHash2['default'],
  html5: _historyHtml52['default']
};

/**
 * Router constructor
 *
 * @param {Object} [options]
 */

var Router = function Router() {
  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _ref$hashbang = _ref.hashbang;
  var hashbang = _ref$hashbang === undefined ? true : _ref$hashbang;
  var _ref$abstract = _ref.abstract;
  var abstract = _ref$abstract === undefined ? false : _ref$abstract;
  var _ref$history = _ref.history;
  var history = _ref$history === undefined ? false : _ref$history;
  var _ref$saveScrollPosition = _ref.saveScrollPosition;
  var saveScrollPosition = _ref$saveScrollPosition === undefined ? false : _ref$saveScrollPosition;
  var _ref$transitionOnLoad = _ref.transitionOnLoad;
  var transitionOnLoad = _ref$transitionOnLoad === undefined ? false : _ref$transitionOnLoad;
  var _ref$suppressTransitionError = _ref.suppressTransitionError;
  var suppressTransitionError = _ref$suppressTransitionError === undefined ? false : _ref$suppressTransitionError;
  var _ref$root = _ref.root;
  var root = _ref$root === undefined ? null : _ref$root;
  var _ref$linkActiveClass = _ref.linkActiveClass;
  var linkActiveClass = _ref$linkActiveClass === undefined ? 'v-link-active' : _ref$linkActiveClass;

  _classCallCheck(this, Router);

  /* istanbul ignore if */
  if (!Router.installed) {
    throw new Error('Please install the Router with Vue.use() before ' + 'creating an instance.');
  }

  // Vue instances
  this.app = null;
  this._views = [];
  this._children = [];

  // route recognizer
  this._recognizer = new _routeRecognizer2['default']();
  this._guardRecognizer = new _routeRecognizer2['default']();

  // state
  this._started = false;
  this._currentRoute = {};
  this._currentTransition = null;
  this._previousTransition = null;
  this._notFoundHandler = null;
  this._beforeEachHooks = [];
  this._afterEachHooks = [];

  // feature detection
  this._hasPushState = typeof window !== 'undefined' && window.history && window.history.pushState;

  // trigger transition on initial render?
  this._rendered = false;
  this._transitionOnLoad = transitionOnLoad;

  // history mode
  this._abstract = abstract;
  this._hashbang = hashbang;
  this._history = this._hasPushState && history;

  // other options
  this._saveScrollPosition = saveScrollPosition;
  this._linkActiveClass = linkActiveClass;
  this._suppress = suppressTransitionError;

  // create history object
  var inBrowser = _util2['default'].Vue.util.inBrowser;
  this.mode = !inBrowser || this._abstract ? 'abstract' : this._history ? 'html5' : 'hash';

  var History = historyBackends[this.mode];
  var self = this;
  this.history = new History({
    root: root,
    hashbang: this._hashbang,
    onChange: function onChange(path, state, anchor) {
      self._match(path, state, anchor);
    }
  });
};

exports['default'] = Router;

Router.installed = false;

/**
 * Installation interface.
 * Install the necessary directives.
 */

Router.install = function (Vue) {
  /* istanbul ignore if */
  if (Router.installed) {
    (0, _util.warn)('already installed.');
    return;
  }
  (0, _routerApi2['default'])(Vue, Router);
  (0, _routerInternal2['default'])(Vue, Router);
  (0, _directivesView2['default'])(Vue);
  (0, _directivesLink2['default'])(Vue);
  (0, _override2['default'])(Vue);
  _util2['default'].Vue = Vue;
  // 1.0 only: enable route mixins
  var strats = Vue.config.optionMergeStrategies;
  if (strats) {
    // use the same merge strategy as methods (object hash)
    strats.route = strats.methods;
  }
  Router.installed = true;
};

// auto install
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Router);
}
module.exports = exports['default'];